module.exports = __webpack_public_path__ + "static/media/Vector.02c92e79.svg";